import axios from 'axios'

function queryMenu (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/dataSource/queryMenu/${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function querySearch (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/search/querySearch`,
      method: 'POST',
      data: param,
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function queryVersion (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/dataSource/queryVersion/${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function searchResult (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/search`,
      method: 'POST',
      data: param,
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function queryDocument (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/dataSource/queryDocument${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function insertFeedback (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/feedback/insertFeedback`,
      method: 'POST',
      data: param,
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function queryForumComment (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/forum/queryForumComment${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function queryMenuByNameAndLang (param) {

  var urlPublic = "portal-wisepaas-ews.axa.wise-paas.com.cn";
  var urlPrivate = "docs.wise-paas.advantech.com.cn";
  var url = window.location.hostname;
  var publicval = 1;
  if(url == urlPublic){
    publicval = 2;  // Private
  }else if(url == urlPrivate){
    publicval = 3;  // All
  }else{
    publicval = 1;  // Public
  }
  param = param+"&public="+publicval;
  //console.log(param);

  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/dataSource/queryMenuByNameAndLang${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function queryDocumentByNameAndVersionAndLang (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/dataSource/queryDocumentByNameAndVersionAndLang${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function downloadAllProductPDF (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/resource/pdf/product${param}&timestamp=${new Date().getTime()}`,
      method: 'GET',
      timeout: {
        client: 10 * 1000
      }
    }
    axios(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export default {
  queryMenu,
  querySearch,
  queryVersion,
  searchResult,
  queryDocument,
  insertFeedback,
  queryForumComment,
  queryMenuByNameAndLang,
  queryDocumentByNameAndVersionAndLang,
  downloadAllProductPDF
}
